<template>

    <transition name="info">
        <div class="top-info" v-show="topInfo.type" :class="topInfo.type">
            <div class="top-info-wrapper">
                <div class="top-info-content">
                    <span v-if="topInfo.icon" class="icon">
                        <svg v-if="topInfo === 'success'"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            fill="none"
                            version="1.1"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"><g><g><path d="M12,21.5C17.2467,21.5,21.5,17.2467,21.5,12C21.5,6.75329,17.2467,2.5,12,2.5C6.75329,2.5,2.5,6.75329,2.5,12C2.5,17.2467,6.75329,21.5,12,21.5ZM11.56217,16.4985L18.0303,10.03033L16.9697,8.96967L11.43784,14.5015L7.46046,11.40798L6.53955,12.592L11.56217,16.4985Z"
                                fill-rule="evenodd"
                                fill="#009B67"
                                fill-opacity="1"/></g></g></svg>
                        <svg v-else
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            fill="none"
                            version="1.1"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"><g><g><path d="M12,21.5C17.2467,21.5,21.5,17.2467,21.5,12C21.5,6.75329,17.2467,2.5,12,2.5C6.75329,2.5,2.5,6.75329,2.5,12C2.5,17.2467,6.75329,21.5,12,21.5ZM13,14L13,7L11,7L11,14L13,14ZM13,18L13,16L11,16L11,18L13,18Z"
                            fill-rule="evenodd"
                            fill="#FAAA32"
                            fill-opacity="1"/></g></g></svg>
                    </span>
                    <span class="content"
                        v-html='$t(topInfo.msgIndex, lang,{
                            supportTeamLink:
                                topInfo.msgIndex.includes("paypal_error") ?
                                    config.support_team :
                                    null
                        })'></span>
                    <span class="operation" v-if="showOperation" @click="topInfo.operation">{{ topInfo.operationIndex?$t(topInfo.operationIndex):$t('dashboard.device_detail.details') }}</span>
                </div>
                <span class="icon-cross2 close-icon" @click="closeTopInfo"></span>
            </div>
        </div>
    </transition>

</template>

<script lang="ts">
import Vue from 'vue';
import { config } from 'CONFIG';
import { NOOP } from '@/utils';

export default Vue.extend({
    data () {

        return {
            config
        };

    },
    computed: {

        topInfo(): any {

            return this.$store.getters.topInfo;

        },
        lang(): string  {

            return this.$store.getters.lang;

        },

        showOperation(): boolean {

            return this.topInfo.operation && this.topInfo.operation !== NOOP;

        }

    },
    methods: {
        async closeTopInfo () {

            await this.topInfo.closeOperation?.();
            this.$store.dispatch( 'closeTopInfo' ).catch( console.error );

        }
    }

});

</script>

<style lang="less">

    .top-info {
        /* height: 40px; */
        font-size: 20px;
        width: 100%;
        line-height: 40px;
        transform: translate3d(0, 100%, 0);
        position: absolute;
        bottom: 0;
        z-index: -1;
        color: #3D3D3D;
        font-family: @font_02;
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        letter-spacing: 0em;
        display: flex;
        justify-content: center;
        .top-info-wrapper{
            width: 1032px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 16px 24px;
            @media @mobile{
                width: 100%;
                padding: 8px 16px;
            }
            .top-info-content{
                display: flex;
                align-items: center;
                gap: 8px;
                @media @mobile{
                    width: 100%;
                    gap: 0px;
                }
                .icon{
                    display: flex;
                    @media @mobile{
                        margin-right: 8px;
                    }
                }
                .content{
                    @media @mobile{
                        min-width: 0;
                        margin-right: 10px;
                    }
                }
                .operation{
                    font-weight: 600;
                    cursor: pointer;
                    @media @mobile{
                        margin-right: 12px;
                    }
                }
                svg{
                    height: 24px;
                    width: 24px;
                }
            }
            .close-icon{
                color: @black_04;
                font-size: 13px;
                cursor: pointer;
                @media @mobile{
                    font-size: 9px;
                }
            }

        }
    }

    .top-info.error {
        background-color: #FCE5E1;
        .operation{
            color: @error;
        }
        svg{
            path{
                fill: @error;
            }
        }
    }

    .top-info.success {
        background-color: #E8FAF0;
        .operation{
            color: @right;
        }
        svg{
            path{
                fill: @right;
            }
        }
    }

    .top-info.warning {
        background-color: #FFECDB;
        .operation{
            color: #FF7B00
        }
        svg{
            path{
                fill: @warning;
            }
        }
    }

    .info-enter-active, .info-leave-active {
      transition: all 0.3s
    }

    .info-enter, .info-leave-to {
      transform: translate3d(0, 0, 0)
    }

</style>
